<template>
    <div>
        <div class="sec_copyright">
            <div class="sec_mbox sec_copyrightBox clearfix">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="6">
                        <div class="sec_copyrightF">
                            <p class="sec_copyrightTitle">平台描述</p>
                            <p class="sec_copyrightCon">ANVA为移动APP预置与分发渠道提供APP安全检测服务，具体包括应用商店、网盘、广告平台等APP分发渠道。根据属地化管理要求，CNCERT及各CNCERT分中心对应用商店中出现的恶意程序进行通知下架处理。
                            </p>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6">
                        <div class="sec_copyrightS">
                            <p class="sec_copyrightTitle">导航</p>
                            <ul style="margin-bottom: 0px;">
                                <li>
                                    <router-link to="/index">首页</router-link>
                                </li>
                                <li>
                                    <router-link to="/appstore-public/center-list">排名</router-link>
                                </li>
                                <li>
                                    <router-link to="/appstore-public/virusApp-list">APP黑名单</router-link>
                                </li>
                                <li>
                                    <router-link to="/appstore-public/cncert-list">CNCERT通报</router-link>
                                </li>
                                <li>
                                    <router-link to="/appstore-public/webinfo-list">信息发布</router-link>
                                </li>
                                <li>
                                    <router-link to="/appstore-public/toReport">匿名举报</router-link>
                                </li>
                                <li></li>
                            </ul>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6">
                        <div class="sec_copyrightT">
                            <p class="sec_copyrightTitle">合作伙伴</p>
                            <ul>
                                <li>
                                    <a href="https://anva.org.cn" target="_blank">ANVA业务统一受理平台</a>
                                </li>
                                <li>
                                    <a href="https://share.anva.org.cn" target="_blank">网络安全威胁信息共享平台</a>
                                </li>
                                <li>
                                    <a href="https://white.anva.org.cn" target="_blank">移动互联网应用自律白名单发布平台</a>
                                </li>
                                <li>
                                    <a href="https://ca.anva.org.cn" target="_blank">移动互联网应用程序开发者数字证书管理平台</a>
                                </li>
                            </ul>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6">
                        <div class="sec_copyrightW">
                            <p class="sec_copyrightTitle">关注我们</p>
                            <ul class="clearfix">
                                <li>
                                    <img src="/image/appstore/secxl.png">
                                    <p class="sec_wxxl">新浪微博</p>
                                </li>
                                <li style="margin-right: 0px;">
                                    <img src="/image/appstore/secwx.png">
                                    <p class="sec_wxxl">微信公众号</p>
                                </li>
                            </ul>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- foot -->
        <div class="sec_foot">
            <div class="sec_mbox clearfix">
                <p class="sec_footZ">主办：中国反网络病毒联盟</p>
                <p class="sec_footI">
                    <a href="http://www.miibeian.gov.cn" target="_blank" style="color: #757980;">ICP:京10012421号</a>
                </p>
                <a href="javascript:;" class="sec_footE">如有问题请联系：anvaregister@cert.org.cn</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'appstore-copyright'
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/style/appstore/base";
    @import "~@/assets/style/appstore/style";
</style>